import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Collapse, Row, Col, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import ListRatings from '../ListRatings';
import { useOwnerContext } from '../../../../../contexts/OwnerContext/OwnerContext';

const { TabPane } = Tabs;
const { Panel } = Collapse;

export const RatingInfoCards = ({
  setReviewDrawerOpen,
  form,
  setSupervisionRating,
  setShowReviewDrawer,
  setRefreshData,
  refreshData,
  setEditReviewDrawer,
  setReviewData,
  reviewData
}) => {
  const { t } = useTranslation();
  const { reviewActiveKey, handleChangeQuestionnaireType } = useOwnerContext();

  return (
    <Collapse accordion className="ratings-collapse">
      <Panel header={t('ratings.header_panel')} key="1">
        <Row gutter={[12, 12]}>
          <Col xs={24} xxl={24}>
            <Card
              bordered={false}
              title={
                <Tabs
                  defaultActiveKey={reviewActiveKey}
                  onChange={(key) => handleChangeQuestionnaireType(key)}
                >
                  <TabPane
                    tab={t('ratings.tabs.received_reviews')}
                    key="received_reviews"
                  />
                  <TabPane
                    tab={t('ratings.tabs.left_reviews')}
                    key="left_reviews"
                  />
                </Tabs>
              }
              className="card-with-tabs"
            >
              <ListRatings
                setReviewDrawerOpen={setReviewDrawerOpen}
                form={form}
                setSupervisionRating={setSupervisionRating}
                setShowReviewDrawer={setShowReviewDrawer}
                setRefreshData={setRefreshData}
                refreshData={refreshData}
                setEditReviewDrawer={setEditReviewDrawer}
                setReviewData={setReviewData}
                reviewData={reviewData}
              />
            </Card>
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};

RatingInfoCards.propTypes = {
  setReviewDrawerOpen: PropTypes.func,
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func
  }).isRequired,
  setSupervisionRating: PropTypes.func,
  setShowReviewDrawer: PropTypes.func,
  setRefreshData: PropTypes.func,
  refreshData: PropTypes.bool.isRequired,
  setEditReviewDrawer: PropTypes.func,
  setReviewData: PropTypes.func,
  reviewData: PropTypes.shape({})
};

RatingInfoCards.defaultProps = {
  reviewData: {},
  setReviewDrawerOpen: () => {},
  setSupervisionRating: () => {},
  setShowReviewDrawer: () => {},
  setRefreshData: () => {},
  setEditReviewDrawer: () => {},
  setReviewData: () => {}
};
